import { Component } from 'preact'
import Icon from '../assets'
import { Item, ItemsList } from './interfaces'

interface Props {
  items: ItemsList
  onChange: (items: ItemsList) => void
  searchPlaceholderText?: string
  searchIconWidth?: number
  searchIconHeight?: number
}

interface State {
  value: string
}

function isChangeEvent(event: Event): event is ChangeEvent {
  return !!event.target && 'value' in event.target
}

class DropdownSearchbox extends Component<Props, State> {
  searchboxRef: HTMLElement | null = null

  constructor() {
    super()
    this.setState({ value: '' })

    this.onClear = this.onClear.bind(this)
  }

  componentDidMount() {
    this.makeFocused()
  }

  makeFocused() {
    this.searchboxRef?.focus()
  }

  onInput(event: ChangeEvent): void {
    const input = event.target.value

    this.setState({ value: input })

    this.props.onChange(
      this.props.items.filter((item: Item) => {
        return item.title.toLowerCase().includes(input.toLowerCase())
      })
    )
  }

  onClear() {
    this.setState({ value: '' })
    this.props.onChange(this.props.items)
  }

  render() {
    const {
      searchPlaceholderText = 'Search',
      searchIconWidth = 24,
      searchIconHeight = 24
    } = this.props
    const { value } = this.state
    return (
      <div class='dropdown-searchbox'>
        <Icon icon='search' width={searchIconWidth} height={searchIconHeight} />
        <input
          className='qa-dropdown-search-box'
          id='searchbox'
          type='text'
          placeholder={searchPlaceholderText}
          value={value}
          onInput={(e) => {
            if (isChangeEvent(e)) {
              this.onInput(e)
            }
          }}
          ref={(searchbox) => {
            this.searchboxRef = searchbox
          }}
        />
        {value && (
          <Icon
            customClass='btn-clear-searchbox'
            icon='close'
            onClick={(e: ClickEvent) => {
              e.stopPropagation()
              this.onClear()
            }}
          />
        )}
      </div>
    )
  }
}

export default DropdownSearchbox
